/**
 * Plot Package capability check over the served property-subscription row.
 *
 */
import type { PropertySubscription } from "@/contexts/PropertySubscriptionContext";

/** Whether a property currently grants Plot Package capabilities. */
export function hasActivePropertyPackage(
  subscription: PropertySubscription | null,
): boolean {
  if (subscription?.package_state !== "active") return false;
  if (!subscription.expires_at) return true;
  const expiresAt = Date.parse(subscription.expires_at);
  return Number.isFinite(expiresAt) && expiresAt > Date.now();
}
